import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Row, Col, Card, CardTitle, CardBody, Button } from 'reactstrap'
import * as moment from 'moment'
import ApiService from '../../data/services/ApiService'
import CurrentPlan from './CurrentPlan'
import Invoices from './Invoices'
import toastr from 'toastr'
import PaymentForm from './PaymentForm'
import ComprarTimbresModal from '../../components/pagos/ComprarTimbresModal'

const Index = (props) => {
    const [plans, setPlans] = useState([])
    const [packOptions, setPackOptions] = useState([])
    const [expired, setExpired] = useState(false)
    const [showPaymentForm, setShowPaymentForm] = useState(false)
    const [currentPlan, setCurrentPlan] = useState({})
    const [selectedPack, setSelectedPack] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)
    const [creditsBalance, setCreditsBalance] = useState(null)

    const empresa = props.empresa || {}
    const isCortesia = empresa.cortesia === true
    const isActive = empresa.status === true && empresa.pagante === true

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const response = await ApiService.getPlans()
                setPlans(response.data.plans)
            } catch (error) {
                toastr.error('Error fetching plans')
            }
        }
        fetchPlans()
    }, [])

    useEffect(() => {
        ApiService.getCreditPacks()
            .then(res => setPackOptions(res.data.packs || []))
            .catch(() => {})
    }, [])

    // Intercept ?intent=credits&quantity=X from marketing-site funnel
    useEffect(() => {
        const params = new URLSearchParams(props.location.search)
        const intent = params.get('intent')
        const quantity = parseInt(params.get('quantity'), 10)
        const validQuantities = [10, 25, 50, 100]

        if (intent !== 'credits' || !validQuantities.includes(quantity)) return

        // Clean URL immediately — prevents modal reopening on refresh
        window.history.replaceState({}, '', window.location.pathname)

        ApiService.getCreditPacks()
            .then(res => {
                const packs = res.data.packs || []
                const pack = packs.find(p => p.quantity === quantity && p.status)
                if (pack) {
                    setSelectedPack({ quantity: pack.quantity, price: pack.price, label: pack.label })
                    setModalOpen(true)
                }
            })
            .catch(() => {})
    }, []) // eslint-disable-line

    useEffect(() => {
        if (!empresa._id) {
            return
        }

        const plan = plans.find(p => p._id === empresa.plan)
        setCurrentPlan(plan)
        setExpired(new Date() > new Date(empresa.expirationDate))
    }, [props])

    useEffect(() => {
        if (!empresa._id) {
            return
        }

        const plan = plans.find(p => p._id === empresa.plan)
        setCurrentPlan(plan)
        setExpired(new Date() > new Date(empresa.expirationDate))
    }, [plans])

    const generateBillingPeriodText = (expirationDateISO) => {
        const expirationDate = moment(expirationDateISO)
        const formattedEndDate = expirationDate.format('DD/MMMM/YYYY')
        const startDate = expirationDate.clone().subtract(1, 'month')
        const formattedStartDate = startDate.format('DD/MMMM/YYYY')

        return `Tu periodo actual de facturación va desde el ${formattedStartDate} al ${formattedEndDate}`
    }

    const handlePaymentSuccess = () => {
        setShowPaymentForm(false)
        toastr.success('¡Listo! Tu suscripción ha sido actualizada.')
    }

    if (!empresa._id) {
        return null
    }

    // Cortesia accounts: hide all payment UI
    if (isCortesia) {
        return (
            <React.Fragment>
                <Card>
                    <CardBody>
                        <div style={{ textAlign: 'center', padding: '40px 0' }}>
                            <span style={{ fontSize: 40 }}>🎁</span>
                            <h4 style={{ marginTop: 16 }}>Acceso cortesía activo</h4>
                            <p style={{ color: '#888', maxWidth: 500, margin: '0 auto' }}>
                                Tu cuenta tiene acceso cortesía de Timbrát. No necesitas una suscripción para timbrar facturas.
                            </p>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <Invoices />
                </Card>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Card sm={12}>
                <CardTitle>
                    <Row>
                        <Col sm={6}>Facturación para {empresa.nombre}</Col>
                        <Col sm={6} style={{ textAlign: 'right' }}>
                            {empresa.tipoPlan} {expired && (<>(<span style={{ color: '#B52C21' }}>expirado</span>)</>)}
                        </Col>
                    </Row>
                </CardTitle>
                <CardBody>
                    {expired && (
                        <>
                            <Row>
                                <Col sm={12}>
                                    <strong>Tu suscripción ha expirado</strong>
                                    <p>No te dejes que tu empresa se quede sin facturar, renueva tu plan hoy mismo.</p>
                                </Col>
                            </Row>
                            <CurrentPlan {...props} currentPlan={currentPlan} plans={plans} />
                        </>
                    )}

                    {!expired && empresa.expirationDate && (
                        <>{generateBillingPeriodText(empresa.expirationDate)}</>
                    )}
                </CardBody>
            </Card>

            {plans && currentPlan && (
                <React.Fragment>
                    <Card>
                        <CurrentPlan {...props} currentPlan={currentPlan} plans={plans} expired={expired} />

                        <Button
                            onClick={(e) => {
                                e.preventDefault()
                                setShowPaymentForm(!showPaymentForm)
                            }}
                            className='btn btn-secondary'
                        >
                            {isActive ? 'Cambiar de plan' : expired ? 'Renovar plan' : 'Suscribirme'}
                        </Button>

                        <Row style={{ padding: '24px 0' }}>
                            <Col sm={12}>
                                {showPaymentForm && (
                                    <PaymentForm
                                        currentPlan={currentPlan}
                                        plans={plans}
                                        onSuccess={handlePaymentSuccess}
                                    />
                                )}
                            </Col>
                        </Row>
                    </Card>
                </React.Fragment>
            )}

            {/* Token pack purchase section */}
            <Card>
                <CardTitle>
                    <Row>
                        <Col sm={12}>Timbres adicionales</Col>
                    </Row>
                </CardTitle>
                <CardBody>
                    <p style={{ color: '#555', marginBottom: 20 }}>
                        ¿Se te acabaron los timbres del mes? Compra paquetes de timbres adicionales que se usan automáticamente cuando tu plan se agota.
                    </p>
                    <Row>
                        {packOptions.map((pack) => (
                            <Col key={pack.quantity} sm={6} md={3} style={{ marginBottom: 12 }}>
                                <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: '20px 16px', textAlign: 'center' }}>
                                    <div style={{ fontSize: 24, fontWeight: 'bold', color: '#1a1a2e' }}>{pack.quantity}</div>
                                    <div style={{ fontSize: 13, color: '#888', marginBottom: 8 }}>timbres</div>
                                    <div style={{ fontSize: 18, fontWeight: 'bold', color: '#34c38f', marginBottom: 12 }}>{pack.price} MXN</div>
                                    <Button
                                        color="success"
                                        size="sm"
                                        onClick={() => {
                                            setSelectedPack({ quantity: pack.quantity, price: pack.price, label: pack.label })
                                            setModalOpen(true)
                                        }}
                                    >
                                        Comprar
                                    </Button>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </CardBody>
            </Card>

            <ComprarTimbresModal
                isOpen={modalOpen}
                purchaseType="credits"
                onRequestClose={() => {
                    setModalOpen(false)
                    setSelectedPack(null)
                }}
                pack={selectedPack}
                onSuccess={(newBalance) => {
                    setCreditsBalance(newBalance)
                    setModalOpen(false)
                    setSelectedPack(null)
                }}
            />

            <Card>
                <Invoices />
            </Card>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return { empresa: state.Auth.profile?.empresa || null }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Index))
